import { render, staticRenderFns } from "./CreateEmailAuthRecordsModal.vue?vue&type=template&id=bd048448&scoped=true"
import script from "./CreateEmailAuthRecordsModal.vue?vue&type=script&lang=js"
export * from "./CreateEmailAuthRecordsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailAuthRecordsModal.vue?vue&type=style&index=0&id=bd048448&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd048448",
  null
  
)

export default component.exports